module.exports = __webpack_public_path__ + "media/murisinaidene.06f83cde.mp3";